import {EMigrationStatus} from './MigrationTab/definitions';
import {EPaymentCorrectionType} from './PaymentsTab';
import {ESubscriptionActionType, ESubscriptionCountryType} from './SmsChannelTab/definitions';
import {ECorrectionsTab, EMigrationTab} from './definitions';

export default {
  tabs: {
    [ECorrectionsTab.PAYMENTS]: 'Списания и оплаты',
    [ECorrectionsTab.LICENSES]: 'Лицензии',
    [ECorrectionsTab.SMS_CHANNEL]: 'Анкеты СМС',
    [ECorrectionsTab.MIGRATION]: 'Миграция',
    [ECorrectionsTab.TARIFFS]: 'Изменения тарифов',
  },
  payments: {
    selectType: 'Выберите тип операции',
    notFound: 'Операция не найдена',
    searchResults: 'Результаты поиска',
    type: {
      [EPaymentCorrectionType.STORNO]: 'Сторнировать операцию',
      [EPaymentCorrectionType.CANCEL_STORNO]: 'Отменить сторно',
      [EPaymentCorrectionType.UPDATE_SUM]: 'Изменить сумму операции',
      [EPaymentCorrectionType.CARD_PAYMENTS]: 'Платежи по картам',
    },
    storno: {
      enterEventId: 'Укажите ID операции',
      enterSum: 'Введите сумму',
      invalidEventType: 'Изменить сумму по данному типу операции невозможно',
      duplicateSumError: 'Новая сумма должна отличаться от суммы транзакции',
      companyName: 'Наименование компании',
      paymentType: 'Тип списания',
      licensePayment: 'Списание за лицензию',
      amount: 'Сумма списания с НДС',
      date: 'Дата транзакции',
      currency: 'Валюта списания',
      isSearchCorrectMessage: 'Обязательно убедитесь в корректности запроса по таблицам',
      billedEvent: 'Billed event',
      debtTransaction: 'Debt transaction',
      transaction: 'Transaction',
      id: 'ID',
      originalEventId: 'Original event ID',
      originalEventType: 'Original event Type',
      confirmation: 'Confirmation',
      createdAt: 'Дата',
      eventId: 'Event ID',
      tenantId: 'ID компании',
      reason: 'Reason',
      reasonCode: 'Reason code',
      balanceId: 'Balance ID',
      openingBalance: 'Opening balance',
      state: 'Статус',
      updated: 'Обновлено',
      search: 'Найти',
      comment: 'Комментарий к корректировке',
      button: {
        [EPaymentCorrectionType.STORNO]: 'Сторнировать',
        [EPaymentCorrectionType.CANCEL_STORNO]: 'Отменить сторно',
        [EPaymentCorrectionType.UPDATE_SUM]: 'Изменить сумму',
      },
      confirmModal: {
        title: {
          [EPaymentCorrectionType.STORNO]: 'Уверены? Мы отменяем списание',
          [EPaymentCorrectionType.CANCEL_STORNO]: 'Уверены? Мы отменяем сторно',
          [EPaymentCorrectionType.UPDATE_SUM]: 'Уверены? Мы меняем сумму транзакции',
        },
        message: 'Если это ошибочная операция, то исправить это будет невозможно',
        subtitle: 'Проверьте данные:',
        button: 'Да, продолжить',
      },
      successModal: {
        title: 'Все хорошо!',
        message: 'Запрос принят к исполнению',
      },
    },
    card: {
      search: 'Поиск платежа',
      selectDate: 'Выберите дату',
      selectUser: 'Введите ID пользователя',
      table: {
        date: 'Дата',
        tenant: 'Тенанта',
        paymentId: 'ID платежа',
        sum: 'Сумма',
        status: 'Статус платежа',
      },
      refundButton: 'Сделать полный возврат',
      partialRefundButton: 'Частичный возврат',
      refundModal: {
        title: 'Сделать полный возврат платежа на карту?',
        partialTitle: 'Сделать частичный возврат платежа на карту?',
        check: 'Проверьте данные:',
        sum: 'Введите сумму',
        initialSum: 'Исходная сумма платежа',
        availableRefundSum: 'Остаток платежа после частичных возвратов',
        balanceError: 'На балансе тенанты недостаточная сумма для возврата',
        submitButton: 'Сделать возврат',
      },
      successRefundModal: {
        title: 'Все хорошо!',
        subtitle: 'Возврат платежа инициирован',
      },
    },
  },
  licenses: {
    channelType: 'Укажите тип канала',
    licenseId: 'ID лицензии',
    month: 'Номер месяца',
    year: 'Год',
    eventTable: 'license_billed_event_tab (по указанному периоду)',
    notFound: 'Лицензия не найдена',
    search: 'Поиск',
    notification: 'Операция пролонгации лицензии запущена',
    tr: {
      id: 'ID',
      channel: 'Канал',
      price: 'Стоимость',
      currency: 'Валюта',
      paymentType: 'Тип списания',
      periodStartedAt: 'Начало',
      periodEndedAt: 'Окончание',
      transactionId: 'ID транзакции',
      createdAt: 'Создана',
      updatedAt: 'Обновлена',
      documentId: 'ID документа',
      tenantId: 'ID тенанты',
      subjectId: 'ID отправителя',
      periodMonths: 'Период продления, мес',
      name: 'Название',
      description: 'Примечание',
      licenseStatus: 'Статус лицензии',
      activatedAt: 'Дата активации',
      expiredAt: 'Лицензия действительна до',
      cancelledAt: 'Отменена',
      activeUntil: 'Активирована с ',
      paidUntil: 'Оплачена до',
      temporaryblockedAt: 'Временно заблокировано c',
      paymentCode: 'Код списания',
    },
  },
  smsChannel: {
    subjectLabel: 'Введите subject ID, чтобы найти анкету',
    notFound: 'Нет анкеты с таким Subject ID',
    searchResult: 'Результат поиска',
    channelTable: {
      tenant: 'Номер тенанты',
      channelName: 'Название канала',
      subjectId: 'Subject_ID',
      status: 'Статус',
    },
    channelInfo: {
      commonInfo: 'Данные канала',
      name: 'Внутреннее название канала:',
      tariff: 'Тариф:',
      subject: 'Имя отправителя:',
      subscriptionsInfo: 'Операторы и страны',
      operator: 'Оператор',
      operatorRus: '{{name}} Россия',
      country: 'Страна',
      subscription: 'Тип тарификации',
    },
    editSubscriptionsModal: {
      title: 'Изменить тарификацию SMS',
      submitButton: 'Сохранить изменения',
      operators: 'Российские операторы',
      countries: 'Другие страны',
      action: 'Выберите действие с оператором',
      selectOperator: 'Выберите оператора',
      selectCountry: 'Выберите страну',
      subscription: 'Условия тарификации',
      selectAll: 'Выбрать все',
      smsCommon:
        'Для тарифа {{name}} запрещено изменять набор операторов и типов трафика. Прежде чем продолжить, согласуйте действия с руководством.',
    },
    editSubscriptionsAction: {
      [`${ESubscriptionActionType.ADD}_${ESubscriptionCountryType.RUS}`]: 'Добавить оператора',
      [`${ESubscriptionActionType.EDIT}_${ESubscriptionCountryType.RUS}`]:
        'Изменить условия оператора',
      [`${ESubscriptionActionType.DELETE}_${ESubscriptionCountryType.RUS}`]: 'Удалить оператора',
      [`${ESubscriptionActionType.ADD}_${ESubscriptionCountryType.OTHERS}`]: 'Добавить страну',
      [`${ESubscriptionActionType.DELETE}_${ESubscriptionCountryType.OTHERS}`]: 'Удалить страну',
    },
    successNotification: 'Анкета канала SMS успешно изменена',
  },
  migration: {
    tabs: {
      [EMigrationTab.SUBJECTS]: 'Подписи',
      [EMigrationTab.PRISM]: 'Prism',
    },
    subjects: {
      title: 'Планирование миграции подписи',
      sourceTenantId: 'ID текущей тенанты',
      channelType: 'Тип канала',
      subjectId: 'Подпись',
      licenseId: 'Лицензия',
      targetTenantId: 'ID тенанты для переноса',
      availableTariffId: 'Шаблон тарифа',
      scheduledDate: 'Дата миграции',
      scheduledTime: 'Время миграции',
      migrateOperatorTemplates: 'Перенести/дублировать операторские шаблоны в новую тенанту',
      migrateJivoIntegration: 'Переключить интеграцию Jivo',
      migrateCallbackIntegration: 'Перенести настройки вебхуков',
      migrateHpxIntegration: 'Переключить интеграцию eCC (HPX)',
      blockOldLicense: 'Заблокировать лицензию на старой тенанте',
      submitButton: 'Запланировать миграцию',
      successNotification: 'Миграция успешно запланирована',
      deleteSuccessNotification: 'Запрос на миграцию удалён',
      listTitle: 'Запланированные и выполненные миграции',
      deleteConfirmTitle: 'Удалить запрос на миграцию?',
      deleteConfirmButton: 'Удалить',
      cancelButton: 'Отмена',
      table: {
        id: 'ID',
        sourceTenantId: 'Источник',
        targetTenantId: 'Назначение',
        channelType: 'Канал',
        subjectId: 'Подпись',
        status: 'Статус',
        scheduledAt: 'Запланировано',
        createdAt: 'Создано',
        actions: 'Действия',
      },
      status: {
        [EMigrationStatus.PENDING]: 'Ожидает',
        [EMigrationStatus.IN_PROGRESS]: 'В процессе',
        [EMigrationStatus.COMPLETED]: 'Завершена',
        [EMigrationStatus.FAILED]: 'Ошибка',
      },
      selectPlaceholder: 'Выберите',
    },
    prism: {
      dataLabel: 'Вставьте тело запроса',
      successNotification: 'Миграция успешно запланирована',
      submitButton: 'Запланировать миграцию',
    },
  },
  tariffs: {
    title: 'Массовый перевод с тарифа на тариф',
    channel: 'Канал',
    prevTariff: 'Текущий тариф',
    nextTariff: 'Новый тариф',
    tariffId: 'ID тарифа',
    licenseId: 'ID лицензии',
    activeFrom: 'Дата и время активации тарифа',
    coefficients: 'Перенос коэффициентов',
    prevCoefficients: 'Оставить',
    resetCoefficients: 'Обнулить',
    successNotification: 'Изменение успешно запланировано',
    confirmModal: {
      title: 'Уверены? Вы собираетесь массово перевести тарифы',
      check: 'Проверьте данные:',
      id: 'ID',
      oldTariff: 'Текущий тариф',
      oldLicense: 'Текущая лицензия',
      newTariff: 'Новый тариф:',
      newLicense: 'Новая лицензия:',
      name: 'Название',
      channel: 'Канал',
      documentType: 'Тип договора',
      reseller: 'Реселлер',
      version: 'Версия',
      currency: 'Валюта',
      country: 'Страна',
      data: 'Свойства',
    },
  },
};
